const steps = [
  { num: '01', title: 'Постановка задачи', desc: 'Определяем, зачем компании нужна оценка и какое решение должно быть принято по её результатам.' },
  { num: '02', title: 'Определение компетенций', desc: 'Формируем перечень компетенций и критериев оценки под конкретные должности.' },
  { num: '03', title: 'Подготовка инструментов', desc: 'Выбираем подходящие методы: интервью, практические задания, 360°, тестирование и другие инструменты.' },
  { num: '04', title: 'Проведение оценки', desc: 'Проводим оценочные мероприятия с сотрудниками.' },
  { num: '05', title: 'Анализ результатов', desc: 'Выявляем сильные стороны, зоны развития, потенциальные риски и перспективных сотрудников.' },
  { num: '06', title: 'Рекомендации', desc: 'Формируем конкретные рекомендации по развитию на основе полученных данных.' },
  { num: '07', title: 'План развития', desc: 'Связываем результаты оценки с обучением, практикой, наставничеством и другими инструментами развития.' },
  { num: '08', title: 'Повторная оценка', desc: 'При необходимости через определённый период оцениваем изменения и динамику компетенций.' },
];

export default function AssessmentProcess() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как проходит оценка
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Последовательность шагов — от постановки задачи до плана развития и повторной оценки.
        </p>

        <div className="relative">
          <div className="absolute left-6 md:left-8 top-8 bottom-8 w-0.5 bg-teal-200 hidden md:block"></div>

          <div className="space-y-6 md:space-y-8">
            {steps.map((step, i) => (
              <div key={i} className="relative flex gap-5 md:gap-8 items-start">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-teal-600 text-white rounded-xl flex items-center justify-center flex-shrink-0 relative z-10">
                  <span className="text-base md:text-lg font-extrabold">{step.num}</span>
                </div>
                <div className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 flex-grow">
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}